var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDeviceGatewayDormant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4156 24.4601C13.7785 23.8639 14.426 23.5 15.124 23.5H54.876C55.574 23.5 56.2215 23.8639 56.5844 24.4601L62.7084 34.5209C62.8991 34.8343 63 35.194 63 35.5608V44.5C63 45.6046 62.1046 46.5 61 46.5H9C7.89543 46.5 7 45.6046 7 44.5V35.5608C7 35.194 7.10088 34.8343 7.2916 34.5209L13.4156 24.4601Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4444 34.5H8.55556C7.69645 34.5 7 35.0373 7 35.7V45.3C7 45.9627 7.69645 46.5 8.55556 46.5H61.4444C62.3035 46.5 63 45.9627 63 45.3V35.7C63 35.0373 62.3035 34.5 61.4444 34.5Z",
    fill: "url(#paint0_linear_974_10325)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9545 39.4517H35V42.4062H37.9545V39.4517Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.738636
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8637 39.4517H40.9092V42.4062H43.8637V39.4517Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.738636
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7729 39.4517H46.8184V42.4062H49.7729V39.4517Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.738636
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6821 39.4517H52.7275V42.4062H55.6821V39.4517Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.738636
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 36.5H11.25C10.5596 36.5 10 37.1716 10 38C10 38.8284 10.5596 39.5 11.25 39.5H13.75C14.4404 39.5 15 38.8284 15 38C15 37.1716 14.4404 36.5 13.75 36.5Z",
    fill: "#C5C5C5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 17,
    r: 5,
    fill: "#AAAAAA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_10325",
    x1: 35,
    y1: 34.5,
    x2: 35,
    y2: 46.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeviceGatewayDormant);
export default __webpack_public_path__ + "static/media/img_device_gateway_dormant.49e5e465b4982d6f5572307056b8eb72.svg";
export { ForwardRef as ReactComponent };